/**
 * User UI/content language preference.
 *
 * This drives two things:
 *  1. A UI preference (persisted) — the language the signed-in user prefers. Full UI
 *     localization (labels, RTL) is a later slice; for now this records the choice.
 *  2. The default source language for new cases/messages, so content translation flows the
 *     right way without the user thinking about it (a local Arabic doctor's text defaults to
 *     ar -> en; a reviewer's replies default to en -> ar).
 */
export type Lang = 'ar' | 'en';

const KEY = 'telemedicine.lang';

export function getLang(): Lang {
  const stored = localStorage.getItem(KEY);
  return stored === 'ar' || stored === 'en' ? stored : 'ar';
}

export function setLang(lang: Lang): void {
  localStorage.setItem(KEY, lang);
}

export const LANG_LABELS: Record<Lang, string> = {
  ar: 'العربية',
  en: 'English',
};
